import { createSlice } from "@reduxjs/toolkit";
import { searchDishesAPI } from "../../api/dishes";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const searchDishesSlice = createSlice({
  name: "searchDishes",
  initialState: data,
  reducers: {
    searchDishesSlice(state) {
      state.isLoading = true;
    },
    searchDishesSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    searchDishesSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    searchDishesSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const searchDishesHandler: any =(search: any) => async (dispatch: any) => {
    try {
      dispatch(searchDishesAction.searchDishesSlice());
      const response: any = await searchDishesAPI(search);
      dispatch(searchDishesAction.searchDishesSliceSuccess(response?.data));
    } catch (e: any) {
      dispatch(searchDishesAction.searchDishesSliceFailure(e?.response?.data));
    }
  };
export default searchDishesSlice.reducer;
export const searchDishesAction = searchDishesSlice.actions;
